import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import { NOTIFICATIONS } from "./types";
import {
  getNotifications,
  postMarkAllRead,
  postMarkRead,
  createNotification,
} from "./requests";
import { INotification } from "~/types/notifications";
import { ISidebarCount } from "../sidebarCounts/types";

export const useGetNotifications = () =>
  useQuery<INotification[]>(NOTIFICATIONS, () => getNotifications(), {
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    staleTime: 0, // Always consider data stale
    cacheTime: 0, // Don't cache
    refetchInterval: 5000, // Poll every 5 seconds
    refetchIntervalInBackground: true,
  });

export const useMarkAllNotificationsRead = () => useMutation(postMarkAllRead);

export const useMarkNotificationRead = () => useMutation(postMarkRead);

export const useGetUnreadNotifications = () =>
  useQuery<ISidebarCount>(
    [...NOTIFICATIONS, "unread"],
    async () => {
      let notifications = await getNotifications();
      notifications = notifications.filter(
        (notification: INotification) => !notification.is_read
      );
      return { count: notifications.length };
    },
    {
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      refetchOnReconnect: true,
      staleTime: 0, // Always consider data stale
      cacheTime: 0, // Don't cache
      refetchInterval: 5000, // Poll every 5 seconds
      refetchIntervalInBackground: true,
    }
  );

export const useCreateNotification = () =>
  useMutation(createNotification, {
    onSuccess: () => {
      // This will be handled by the component using this mutation
    },
  });
